import PropTypes from 'prop-types';
import { SimpleForm, usePermissions, useTranslate } from 'react-admin';
import CustomCreate from '@/components/global/list/CustomCreate.jsx';
import { RightDrawer } from '@/components/global/drawers/RightDrawer';
import TagCategoryToolbar from '@/components/global/tags/TagCategoryToolbar';
import { BrandBasicInfo } from '@/components/brand/forms/BrandBasicInfo.jsx';
import { BrandConfigurationSection } from '@/components/brand/forms/BrandConfigurationSection.jsx';
import { transformBrandPayload } from '@/components/brand/validators/brandValidators.js';

export const BrandForm = ({ handleClose, showRetailChain = true, lockedRetailChain = null, onSubmit }) => {
    const translate = useTranslate();

    return (
        <SimpleForm
            defaultValues={{
                overrideConfiguration: false,
                ...(lockedRetailChain ? { lockedRetailChainId: lockedRetailChain.id } : {}),
            }}
            toolbar={<TagCategoryToolbar onCancel={handleClose} cancelLabel={translate('common.cancel')} saveLabel={translate('common.save')} />}
            {...(onSubmit ? { onSubmit } : {})}
        >
            <BrandBasicInfo showRetailChain={showRetailChain} lockedRetailChain={lockedRetailChain} />
            <BrandConfigurationSection />
        </SimpleForm>
    );
};

BrandForm.propTypes = {
    handleClose: PropTypes.func,
    showRetailChain: PropTypes.bool,
    lockedRetailChain: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string,
    }),
    onSubmit: PropTypes.func,
};

export const BrandCreate = ({ handleClose = () => {} }) => {
    const { isLoading, permissions } = usePermissions();
    const translate = useTranslate();

    if (isLoading || !permissions?.isAdmin) {
        return null;
    }

    return (
        <RightDrawer handleClose={handleClose} title={translate('resources.brand.labels.create')}>
            <CustomCreate handleClose={handleClose} transform={transformBrandPayload}>
                <BrandForm handleClose={handleClose} />
            </CustomCreate>
        </RightDrawer>
    );
};

BrandCreate.propTypes = {
    handleClose: PropTypes.func,
};
